import React, {Fragment} from "react";
import debounce from "lodash-es/debounce";
import classNames from "classnames";
import TextInput from "../form/TextInput";
import config from "../../config/config";
import {loadComponent} from "../../utils/components";
import {optionsTemplate} from "../../utils/formatters";
import Button from "../form/Button";
import {connect} from "react-redux";
import {activeMenu, setContent, toggleMenu} from "../../actions";
import Icon from "../form/Icon";

const searches = [
    {
        component: "partner",
        tabName: "Partnerek",
        count: 3,
        view: ["partner_id"],
        filter: (search) => ({
            filters: [
                {field: "partner_id", value: search, operator: "like"},
                {field: "taxid", value: search, operator: "like"},
                {field: "eu_taxid", value: search, operator: "like"},
                {field: "name", value: search, operator: "like"}
            ], operator: "OR"
        }),
        search: () => undefined,
        onClick: (e, item, setContent) => setContent("partner", {partner_id: item.partner_id}),
        template: optionsTemplate("partner")
    },
    {
        component: "product",
        tabName: "Termékek",
        count: 3,
        view: ["id"],
        filter: (search) => ({
            filters: [
                {field: "id", value: search, operator: "like"},
                {field: "base_product_id", value: search, operator: "like"},
                {field: "displayname", value: search, operator: "like"},
                {field: "sku", value: search, operator: "like"},
                {field: "barcode", value: search, operator: "like"},
            ], operator: "OR"
        }),
        search: () => undefined,
        onClick: (e, item, setContent) => setContent("product", {id: item.id}),
        template: optionsTemplate("product")
    },
];

class GlobalSearch extends React.Component {

    shiftCount = 0;

    searches = [];

    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            search: '',
            tab: null,
            results: [],
        };
        this.doublePressCancel = debounce(() => {
            this.shiftCount = 0;
        },300);
        this.searchLater = debounce(() => {
            this.search();
        },300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.search !== this.state.search) {
            this.searchLater();
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    search = () => {
        const search = this.state.search.trim();
        if (search.length >= (this.props.minLength || config.minimumLengthOfSearch)) {
            this.setState({results: []}, () => {
                this.searches.map((search) => search && search.cancel());
                this.searches = searches.map((searchConfig, searchIndex) => {
                    return this.searchQuery(searchConfig, searchIndex);
                });
            });
        } else {
            this.setState({results: []});
            this.forceUpdate();
        }
    }

    searchQuery = (searchConfig, searchIndex) => {
        const search = this.state.search.trim();
        const countPerComponent = this.props.countPerComponent || 2;
        let view = searchConfig.template instanceof Object ? (searchConfig.template.view || []) : [];
        if (searchConfig.view) {
            view = [...view, ...searchConfig.view];
        }
        let searchParams = {};
        if (searchConfig.search instanceof Function) {
            searchParams = searchConfig.search(search);
            if (!(searchParams instanceof Object)) {
                searchParams = {search: searchParams};
            }
        } else {
            searchParams = {search};
        }
        let abort = false;
        let request = null;
        let results = this.state.results;
        const promise = new Promise((resolve, reject) => {
            request = loadComponent("componentlist", {
                withheader: 1,
                component: searchConfig.component,
                filter: searchConfig.filter instanceof Function ? searchConfig.filter(search) : searchConfig.filter,
                page: ((results[searchIndex] || {}).page || 0) + 1,
                ...searchParams,
                itemsperpage: searchConfig.count || countPerComponent,
                view
            });
            request.then((response) => {
                if (abort) return;
                let results = this.state.results;
                results[searchIndex] = {...response, items: [...((results[searchIndex] || {}).items || []), ...response.items]};
                this.searches[searchIndex] = null;
                this.setState({results});
                resolve(response);
            });
        });
        promise.cancel = () => {
            abort = true;
            request && request.abort();
        }
        return promise;
    }

    handleKeyPress = (event) => {
        if (event.which === 16) {
            if (this.state.opened) return;
            this.doublePressCancel();
            this.shiftCount++;
            if (this.shiftCount === 2) {
                this.setState({opened: true}, () => {
                    this.searchInput && this.searchInput.select();
                });
            }
        } else if (event.which === 27) {
            this.close();
        }
    }

    close = () => {
        this.setState({opened: false});
    }

    render() {
        return (
            this.state.opened && <Fragment>
                <div className="global-search">
                    <div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="search">
                                    <Icon lib="fa" name="search" />
                                    <TextInput
                                        ref={(search) => this.searchInput = search}
                                        name="search"
                                        label={false}
                                        value={this.state.search}
                                        saveChanges={(field, search) => {
                                            this.setState({search});
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="buttons">
                                    <Button size="xs" color={this.state.tab === null ? "primary" : "default"} onClick={() => this.setState({tab: null})} >Összes</Button>{searches.map((search, idx) => search.tabName ? <Button size="xs" color={this.state.tab === idx ? "primary" : "default"} key={idx} onClick={() => this.setState({tab: idx})} >{search.tabName}</Button> : null)}
                                </div>
                                <div className={this.state.tab === null ? "results all" : "results"}>
                                    {this.state.results.map((response, searchIndex) => {
                                        let searchConfig = searches[searchIndex];
                                        let content = null;
                                        if (response.items.length) {
                                            const Template = searchConfig.template;
                                            content = <Fragment>
                                                {searchConfig.tabName && <div className="tab-name"><span>{searchConfig.tabName}</span></div>}
                                                {response.items.map((item, idx) => {
                                                    return <div className="result" onClick={(e) => searchConfig.onClick && searchConfig.onClick(e, item, (option, params) => {this.props.setContent(option, params); this.setState({opened: false})})}><Template key={idx} {...item} /></div>;
                                                })}
                                                {!this.searches[searchIndex] && response.fullcount > response.items.length && <a className="more" onClick={(e) => {e.preventDefault(); !this.searches[searchIndex] ? this.searches[searchIndex] = this.searchQuery(searchConfig, searchIndex) : null}}>... {response.fullcount - response.items.length} db</a>}
                                            </Fragment>;
                                        }
                                        return content;
                                    }).filter((search, idx) => this.state.tab === null || this.state.tab === idx)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div onClick={this.close} className="modal-backdrop fade in show"/>
            </Fragment>
        );
    }
}

export default connect(() => {}, {setContent})(GlobalSearch);